<!--
 * @Author: zhouxingtong
 * @Email: 495144492@qq.com
 * @Date: 2023-06-12 14:07:01
 * @LastEditors: zhouxingtong
 * @LastEditTime: 2025-12-31 16:37:26
 * @Description: 
-->
<template>
	<div class="container">
		<a-form-model ref="form" :model="form" :label-col="{span: 3}" :wrapper-col="{span: 12}">
			<a-form-model-item label="商家微官网转发标题设置：" prop="mini_shop_index_share_title">
				<a-input placeholder="请输入商家微官网转发标题" v-model="form.mini_shop_index_share_title" />
				<template #help>
					<div class="flex text-sm form-item-mark">
						<div class="text-theme-red mr-2">注:</div>
						<div>
							<p>
								支持的变量：<span class="text-theme-red">#餐厅名称# </span>
								<span class="text-theme-red">#销售经理姓名# </span>
								<span class="text-theme-red">#销售经理职位# </span>
								使用时将带双#号的变量输入至标题即可
							</p>
						</div>
					</div>
				</template>
			</a-form-model-item>
			<a-form-model-item label="邀请函转发标题设置：" prop="mini_shop_invitation_title">
				<a-input placeholder="请输入邀请函转发标题" v-model="form.mini_shop_invitation_title" />
				<template #help>
					<div class="flex text-sm form-item-mark">
						<div class="text-theme-red mr-2">注:</div>
						<div>
							<p>
								支持的变量：<span class="text-theme-red">#预订人姓名# </span>
								<span class="text-theme-red">#预订人性别# </span>
								使用时将带双#号的变量输入至标题即可
							</p>
						</div>
					</div>
				</template>
			</a-form-model-item>
			<!-- <a-form-model-item
				label="餐厅主页顶部背景图"
				prop="mini_shop_index_top_background_image"
				ref="mini_shop_index_top_background_image">
				<image-uploader
					v-model="form.mini_shop_index_top_background_image"
					@success="
						$refs.mini_shop_index_top_background_image.onFieldBlur()
					"
					@remove="
						$refs.mini_shop_index_top_background_image.onFieldBlur()
					" />
				<template #help>
					<div class="flex text-sm mb-4 form-item-mark">
						<div class="text-theme-red mr-2">注:</div>
						<div>
							<p>1、图片格式必须为 jpg / png</p>
							<p>2、建议尺寸：宽750px，高1100px</p>
						</div>
					</div>
				</template>
			</a-form-model-item> -->
			<!-- <a-form-model-item
				label="邀请函顶部背景图"
				prop="mini_shop_invitation_top_background_image"
				ref="mini_shop_invitation_top_background_image">
				<image-uploader
					v-model="form.mini_shop_invitation_top_background_image"
					@success="
						$refs.mini_shop_invitation_top_background_image.onFieldBlur()
					"
					@remove="
						$refs.mini_shop_invitation_top_background_image.onFieldBlur()
					" />
				<template #help>
					<div class="flex text-sm mb-4 form-item-mark">
						<div class="text-theme-red mr-2">注:</div>
						<div>
							<p>1、图片格式必须为 jpg / png</p>
							<p>2、建议尺寸：宽750px，高1100px</p>
						</div>
					</div>
				</template>
			</a-form-model-item> -->
			<a-form-model-item label="邀请函公告设置：" prop="invitation_tip">
				<a-input placeholder="请输入邀请函公告" v-model="form.invitation_tip" />
				<template #help>
					<div class="flex text-sm form-item-mark">
						<div class="text-theme-red mr-2">注:</div>
						<div>
							<p>输入保存后此公告将展示在邀请函顶部位置，若字数过多，会滚动显示</p>
						</div>
					</div>
				</template>
			</a-form-model-item>
			<a-form-model-item label="顾客转发邀请函标题设置：" prop="mini_shop_customer_invitation_title">
				<a-input placeholder="请输入顾客转发邀请函标题" v-model="form.mini_shop_customer_invitation_title" />
				<template #help>
					<div class="flex text-sm form-item-mark">
						<div class="text-theme-red mr-2">注:</div>
						<div>
							<p>支持的变量：<span class="text-theme-red">#预订人姓名# </span> <span class="text-theme-red">#预订餐位# </span>使用时将带双##号的变量输入至标题即可</p>
						</div>
					</div>
				</template>
			</a-form-model-item>
			<a-form-model-item label="邀请函开屏设置：" prop="mini_shop_customer_banner" ref="banner">
				<image-uploader v-model="form.mini_shop_customer_banner" @success="$refs.banner.onFieldBlur()" @remove="$refs.banner.onFieldBlur()" />
				<template #help>
					<div class="flex text-sm form-item-mark">
						<div class="text-theme-red mr-2">注:</div>
						<div>
							<p>设置后，打开小程序邀请函时将会展示2s此开屏图</p>
						</div>
					</div>
				</template>
			</a-form-model-item>

			<a-form-model-item label="文字版邀请函设置" prop="invitationComposing">
				<a-button ghost type="primary" size="large" icon="edit" @click="openCustomModal">点击设置自定义内容</a-button>
			</a-form-model-item>

			<a-form-model-item label="邀请函内容排版" prop="invitationComposing">
				<a-button ghost type="primary" size="large" icon="edit" @click="onHandleComposingPopup">点击设置内容排序</a-button>
			</a-form-model-item>

			<a-form-model-item label="品牌专属邀请函主图：" prop="mini_shop_invitation_new_banner" ref="invitationNewBanner">
				<div style="width: 145px; overflow: hidden">
					<a-upload
						:show-upload-list="false"
						:before-upload="
							file => {
								onCropperImage(file, 'mini_shop_invitation_new_banner')
							}
						"
						accept="image/*"
						v-if="!form.mini_shop_invitation_new_banner">
						<div class="itemBox uploadBtn">
							<a-icon type="plus" />
							<div class="ant-upload-text">上传照片</div>
						</div>
					</a-upload>
					<image-uploader v-else v-model="form.mini_shop_invitation_new_banner" model-type="Str" :max="1" :showUploadList="false" :multiple="false" @success="$refs.invitationNewBanner.onFieldBlur()" @remove="$refs.invitationNewBanner.onFieldBlur()" />
				</div>
				<!-- <image-uploader v-model="form.mini_shop_invitation_new_banner" @success="$refs.invitationNewBanner.onFieldBlur()" @remove="$refs.invitationNewBanner.onFieldBlur()" /> -->
				<template #help>
					<div class="flex text-sm form-item-mark">
						<div class="text-theme-red mr-2">注:</div>
						<div>
							<p>请上传750*780px的图片</p>
						</div>
					</div>
				</template>
			</a-form-model-item>

			<a-form-model-item label="品牌专属邀请函标签图：" prop="mini_shop_invitation_new_tag_banner" ref="invitationNewTagBanner">
				<div style="width: 145px; overflow: hidden">
					<a-upload
						:show-upload-list="false"
						:before-upload="
							file => {
								onCropperImage(file, 'mini_shop_invitation_new_tag_banner')
							}
						"
						accept="image/*"
						v-if="!form.mini_shop_invitation_new_tag_banner">
						<div class="itemBox uploadBtn">
							<a-icon type="plus" />
							<div class="ant-upload-text">上传照片</div>
						</div>
					</a-upload>
					<image-uploader v-else v-model="form.mini_shop_invitation_new_tag_banner" model-type="Str" :max="1" :showUploadList="false" :multiple="false" @success="$refs.invitationNewTagBanner.onFieldBlur()" @remove="$refs.invitationNewTagBanner.onFieldBlur()" />
				</div>
				<!-- <image-uploader v-model="form.mini_shop_invitation_new_tag_banner" @success="$refs.invitationNewTagBanner.onFieldBlur()" @remove="$refs.invitationNewTagBanner.onFieldBlur()" /> -->
				<template #help>
					<div class="flex text-sm form-item-mark">
						<div class="text-theme-red mr-2">注:</div>
						<div>
							<p>请上传690*200px的图片</p>
						</div>
					</div>
				</template>
			</a-form-model-item>

			<a-form-model-item :wrapper-col="{span: 2, offset: 22}">
				<a-button block type="primary" size="large" @click="showModal">保存</a-button>
			</a-form-model-item>
		</a-form-model>
		<!-- 批量导入菜单 -->
		<a-modal width="500px" :visible.sync="composingVisible" :title="composingTitle" :confirm-loading="composingLoading" @cancel="composingVisible = false" @ok="composingVisible = false">
			<div id="composing-list">
				<div class="composing-item" v-for="item in invitationComposing" :key="item.value" v-if="item.value !== 0">
					{{ item.name }}
					<img class="icon-sort" src="../../assets/switch.png" />
				</div>
			</div>
		</a-modal>
		<!-- 上传图片裁剪 -->
		<a-modal v-model:visible="cropperImageConfig.show" title="图片裁剪" width="80%" :bodyStyle="{height: '70vh', maxheight: '800px', overflow: 'auto'}" @cancel="closeCropperModal">
			<vue-cropper ref="cropper" :img="cropperImageConfig.url" :outputSize="1" :outputType="'png'" :autoCrop="true" :fixed="true" :fixedNumber="cropperImageConfig.fixedNumber" />
			<div slot="footer" class="modal-footer">
				<a-button @click="closeCropperModal">取消</a-button>
				<a-button @click="viewCropperImage">预览</a-button>
				<a-button type="primary" @click="handleConfirmCropper">确定</a-button>
			</div>
		</a-modal>
		<!-- 上传图片预览 -->
		<a-modal v-model:visible="cropperImageConfig.viewShow" @cancel="closeViewShowModal" title="预览效果" :bodyStyle="{display: 'flex', justifyContent: 'center'}">
			<div class="imageCropperView-box">
				<img v-if="cropperImageConfig.key === 'mini_shop_invitation_new_tag_banner'" class="imageCropperView-menu" src="https://oss.dinggebaojian.com/mini/menu_view.png" alt="" />
				<img class="imageCropperView-bg" :src="'https://oss.dinggebaojian.com/mini/phone_view' + (cropperImageConfig.key === 'mini_shop_invitation_new_tag_banner' ? 1 : '') + '.png'" />
				<img :class="cropperImageConfig.key === 'mini_shop_invitation_new_tag_banner' ? 'imageCropperView-menu-image' : 'imageCropperView-image'" :src="cropperImageConfig.viewImage" />
			</div>
			<div slot="footer" class="modal-footer">
				<a-button @click="closeViewShowModal">取消</a-button>
				<a-button type="primary" @click="handleConfirmCropper">保存</a-button>
			</div>
		</a-modal>
		<!-- 文字版邀请函 -->
		<a-modal v-model="customVisible" class="customVisible" width="1130px" title="自定义邀请函" okText="保存" :confirmLoading="customOkLoading" @ok="submitCustom" @cancel="customCancel">
			<a-row :gutter="[15, 15]">
				<a-col :span="12">
					<div data-title="【订个包间】" class="custom_template_text" id="customDom">
						<textarea ref="customDom" v-model="customInitTemplate" @input="setNoteLength" />
					</div>
				</a-col>
				<a-col :span="12">
					<div class="custom_template">
						<p class="custom_template_title">选择短信变量：</p>
						<div class="custom_template_space">
							<a-button v-for="(item, index) in customBtn" :key="index" @click="customBtnClickNew(item.value)">{{ item.value }}</a-button>
						</div>
					</div>
				</a-col>
			</a-row>
		</a-modal>
	</div>
</template>

<script>
import _ from 'lodash'
import Sortable from 'sortablejs'
import {Modal} from 'ant-design-vue'
import {ossconfig} from '@/api'
import {setConfig, getConfig} from '@/api/personalization'
import {workSmsTemplateGet} from '@/api/moneyManage'
import {readDicFn} from '@/utils/utils'
import {VueCropper} from 'vue-cropper'
import request from '@/utils/request'
import ImageUploader from '@/components/ImageUploader'

export default {
	name: 'PersonalSetting',
	components: {
		ImageUploader,
		VueCropper
	},
	data() {
		return {
			composingLoading: false,
			composingTitle: '邀请函内容排序',
			composingVisible: false,
			cropperImageConfig: {
				//上传图片配置
				show: false,
				url: ''
			},

			customVisible: false, // 自定义邀请函 visible
			customOkLoading: false, // 自定义邀请函按钮loading
			customBtn: [], // 自定义邀请函内容按钮
			customInitTemplate: '', // 初始化文字版邀请函模版

			form: {
				mini_shop_index_share_title: '', // 餐厅主页转发标题
				mini_shop_index_top_background_image: '', // 餐厅主页顶部背景图
				mini_shop_invitation_title: '', // 邀请函转发标题
				mini_shop_invitation_top_background_image: '', // 邀请函顶部背景图
				mini_shop_customer_invitation_title: '', // 顾客转发邀请函标题设置
				mini_shop_customer_banner: '', // 邀请函开屏设置
				mini_shop_invitation_new_banner: '', // 品牌专属邀请函主图
				mini_shop_invitation_new_tag_banner: '' // 品牌专属邀请函标签图
			},
			invitationCustomText: '',
			invitationComposing: [
				//{
				//	name: '贵宾有话说',
				//	value: 0
				//},
				{
					name: '排菜菜单',
					value: 1
				},
				{
					name: '就餐环境',
					value: 2
				},
				{
					name: '餐厅招牌菜',
					value: 3
				},
				{
					name: '餐位设施',
					value: 4
				},
				{
					name: '商家有话说',
					value: 5
				},
				{
					name: '停车指引',
					value: 6
				}
			]
		}
	},
	created() {
		this.$nextTick(() => {
			this.fetchSetting()
		})
	},
	mounted() {
		this.getCustomBtns()
	},
	methods: {
		readDicFn,

		/**
		 * @description: 获取配置信息
		 * @return {*}
		 */
		async fetchSetting() {
			this.$store.dispatch('loading/startContentLoading')

			const {code, data = {}} = await getConfig()
			if (code === 0) {
				this.form = {...this.form, ...data.userSettings}
				// 文字版邀请函内容
				if (data.custom_text_invitation) this.invitationCustomText = data.custom_text_invitation
				// 邀请函内容排序
				if (data.invitation_composing) this.invitationComposing = data.invitation_composing

				this.initComposingSort()
			}

			this.$store.dispatch('loading/endContentLoading')
		},
		/**
		 * @description: 保存弹窗
		 * @return {*}
		 */
		showModal() {
			Modal.confirm({
				title: '提示',
				content: '确认保存配置吗？',
				onOk: async () => {
					await this.submitSetting()
				}
			})
		},
		/**
		 * @description: 保存表单内容
		 * @return {*}
		 */
		async submitSetting() {
			this.$message.loading({
				content: '正在保存中...',
				key: 'save',
				duration: 0
			})
			const form = _.cloneDeep(this.form)
			// 转换字段
			const {code} = await setConfig({
				config_name: 'userSettings',
				config_value: form
			})
			if (code === 0) {
				this.$message.success({content: '保存成功！', key: 'save'})
				this.fetchSetting()
			}
		},

		/**
		 * @description: 保存内容排序
		 * @return {*}
		 */
		onHandleComposingPopup() {
			if (!this.composingVisible) {
				this.composingVisible = true
				this.initComposingSort()
			}
		},

		/**
		 * @description: 邀请函内容脱拽排序
		 * @return {*}
		 */
		initComposingSort() {
			this.$nextTick(() => {
				const list = document.querySelector('#composing-list')

				if (list) {
					const sortableObj = new Sortable(list, {
						handle: '.composing-item',
						animation: 150,
						sort: true,
						onEnd: async ({newIndex, oldIndex}) => {
							if (newIndex === oldIndex) return

							const currRow = this.invitationComposing.splice(oldIndex, 1)[0]
							this.invitationComposing.splice(newIndex, 0, currRow)

							// 保存邀请函内容排序
							await setConfig({
								config_name: 'invitation_composing',
								config_value: _.cloneDeep(this.invitationComposing)
							})
						}
					})
				}
			})
		},

		/**
		 * @description: 编辑上传品牌主题邀请函
		 * @return {*}
		 * @param {*} file
		 * @param {*} type
		 */
		onCropperImage(file, type) {
			const reader = new FileReader()

			reader.onload = e => {
				let url = ''

				if (typeof e.target.result === 'object') {
					// 把Array Buffer转化为blob 如果是base64不需要
					url = window.URL.createObjectURL(new Blob([e.target.result]))
				} else {
					url = e.target.result
				}

				const proportion1 = [750, 780] //宽高比例 背景比例
				const proportion2 = [343, 100] //宽高比例 背景比例

				this.cropperImageConfig = {
					show: true,
					url,
					viewShow: false,
					viewImage: '',
					key: type,
					fixedNumber: type === 'mini_shop_invitation_new_banner' ? proportion1 : proportion2
				}
			}
			reader.readAsDataURL(file)
			// 阻止默认上传行为
			return false
		},

		/**
		 * @description: 关闭裁剪
		 * @return {*}
		 */
		closeCropperModal() {
			this.cropperImageConfig = {
				show: false,
				url: '',
				viewShow: false,
				viewImage: '',
				key: ''
			}
		},

		/**
		 * @description: 预览裁剪图片
		 * @return {*}
		 * @param {*} url
		 */
		viewCropperImage() {
			this.$refs.cropper.getCropBlob(blob => {
				this.cropperImageConfig.viewImage = URL.createObjectURL(blob)
				this.cropperImageConfig.viewShow = true
			})
		},

		/**
		 * @description: 关闭预览裁剪图片
		 * @return {*}
		 */
		closeViewShowModal() {
			this.cropperImageConfig.viewImage = ''
			this.cropperImageConfig.viewShow = false
		},

		/**
		 * @description: 上传随机字符串
		 * @return {*}
		 * @param {*} e
		 */
		random_string(e) {
			e = e || 32

			const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
			const a = t.length
			let n = ''
			for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))

			return n
		},

		/**
		 * @description: 上传裁剪图
		 * @return {*}
		 */
		async handleConfirmCropper() {
			this.loading = true

			this.$refs.cropper.getCropBlob(async blob => {
				const {
					data: {url: ossUrl, cdn_url, multipart_params: multipartParams}
				} = await ossconfig()

				const formData = new FormData()
				const name = this.random_string(15) + Date.now()

				Object.keys(multipartParams).forEach(index => {
					if (index === 'key') {
						multipartParams.key += name
					}
					formData.append(index, multipartParams[index])
				})

				formData.append('file', blob, `${name}.jpg`)

				await request({url: ossUrl, method: 'post', data: formData}).then(res => {
					this.form[this.cropperImageConfig.key] = cdn_url + res.data.filename

					this.closeCropperModal()
				})

				this.loading = false
			})
		},

		/**
		 * @description: 获取自定义模板btn列表
		 * @return {*}
		 */
		getCustomBtns() {
			workSmsTemplateGet({
				type: 2,
				vars: 'all'
			}).then(res => {
				this.customBtn = (res.data.vars || []).map(item => ({
					label: item.var,
					value: item.text
				}))
				this.hasCustom = Boolean(res.data.template?.sms_content)
				// 模版审核状态
				this.customStatus = res.data.template?.status
				// 自定义短信模版+默认模版
				this.customInitTemplate = this.invitationCustomText || res.data.template.user_content || res.data.template.default
			})
		},

		/**
		 * @description: 打开自定义模板
		 * @return {*}
		 */
		openCustomModal() {
			this.customVisible = true

			this.$nextTick(() => {
				this.setNoteLength()
			})
		},

		/**
		 * @description: 获取短信字数
		 * @return {*}
		 */
		setNoteLength() {
			const contextDom = this.$refs.customDom

			this.noteLength = contextDom.value.length + 6
		},

		/**
		 * @description: 按钮添加变量
		 * @return {*}
		 * @param {*} initword
		 * @param {*} executeKey
		 */
		customBtnClickNew(initword, executeKey = 'customDom') {
			const customDom = this.$refs.customDom
			customDom.focus()
			const pre = customDom.value.substr(0, customDom.selectionStart)
			const post = customDom.value.substr(customDom.selectionEnd)
			customDom.value = pre + initword + post
		},

		/**
		 * @description: 保存自定义模版内容
		 * @return {*}
		 */
		async submitCustom() {
			const customDom = this.$refs.customDom
			let customText = customDom.value
			const customHtml = customText
			const _this = this
			const outKeyArr = ['预订日期', '服务经理电话', '餐厅电话', '餐厅地址', '预订邀请链接']
			customText = customText.replace(/#([^#]*)#/g, function (match, p1) {
				if (outKeyArr.includes(p1)) return ` ${_this.readDicFn(`#${p1}#`, _this.customBtn)} `
				return _this.readDicFn(`#${p1}#`, _this.customBtn)
			})
			this.customOkLoading = true

			// 转换字段
			const {code} = await setConfig({
				config_name: 'custom_text_invitation',
				config_value: customHtml
			})
			if (code === 0) {
				this.$message.success({content: '保存成功！', key: 'save'})
				this.customVisible = false
				this.customOkLoading = false
				this.fetchSetting()
			}
		},

		/**
		 * @description: 关闭自定义模版弹窗
		 * @return {*}
		 */
		customCancel() {
			this.customVisible = false
			this.customOkLoading = false
		}
	}
}
</script>
<style scoped lang="less">
.container {
	padding: 25px 20px 1px 50px;
	margin: 0;
	max-width: 100% !important;
	background-color: #fff;
	border-radius: 4px;
	box-sizing: border-box;
	.form-item-mark {
		padding-bottom: 10px;
		margin-top: 6px;
	}
}

#composing-list {
	height: 400px;
	width: 100%;
	box-sizing: border-box;
	.composing-item {
		position: relative;
		padding-left: 20px;
		margin-bottom: 10px;
		width: 100%;
		height: 50px;
		border: 1px solid #ececec;
		border-radius: 8px;
		text-align: left;
		font-weight: bold;
		font-size: 16px;
		color: #666;
		line-height: 50px;
		.icon-sort {
			position: absolute;
			right: 20px;
			top: 15px;
			width: 20px;
			height: 20px;
			transform: rotate(90deg);
			vertical-align: middle;
		}
	}
}

.imageCropperView-box {
	height: 274px;
	width: 297px;
	box-sizing: border-box;
	position: relative;
	display: flex;
	justify-content: center;
}

.imageCropperView-bg {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	height: 100%;
	width: 100%;
	z-index: 12;
}

.imageCropperView-menu {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	height: 100%;
	width: 100%;
	z-index: 10;
}

.imageCropperView-image {
	height: 100%;
	width: 93%;
	-webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 60%, rgba(0, 0, 0, 0.9) 70%, rgba(0, 0, 0, 0.5) 80%, rgba(0, 0, 0, 0.2) 90%, rgba(0, 0, 0, 0) 100%);
	mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 60%, rgba(0, 0, 0, 0.9) 70%, rgba(0, 0, 0, 0.5) 80%, rgba(0, 0, 0, 0.2) 90%, rgba(0, 0, 0, 0) 100%);
	border-radius: 50px 50px 0 0;
}

.imageCropperView-menu-image {
	z-index: 11;
	position: absolute;
	top: 140px;
	left: 22px;
	height: 50px;
	border-radius: 40px 40px 0 0;
	width: 85%;
	-webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.8) 20%, rgba(0, 0, 0, 0.5) 40%, rgba(0, 0, 0, 0.3) 60%, rgba(0, 0, 0, 0) 100%);
	mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.8) 20%, rgba(0, 0, 0, 0.5) 40%, rgba(0, 0, 0, 0.3) 60%, rgba(0, 0, 0, 0) 100%);
}

.itemBox {
	width: 141px;
	height: 141px;
	padding: 8px;
	border: 1px solid #d9d9d9;
	margin: 0 8px 8px 0;
	border-radius: 4px;
	position: relative;
	.operate_box {
		display: none;
		position: absolute;
		top: 8px;
		left: 8px;
		height: 123px;
		width: 123px;
		background-color: rgba(0, 0, 0, 0.5);
		color: #fff;
		align-items: center;
		justify-content: center;
		::v-deep .anticon {
			margin: 0 4px;
		}
	}
	&:hover .operate_box {
		display: flex;
	}
}

.uploadBtn {
	width: 141px;
	height: 141px;
	padding: 8px;
	text-align: center;
	color: rgba(0, 0, 0, 0.65);
	font-size: 16px;
	font-variant: tabular-nums;
	line-height: 1.5;
	cursor: pointer;
	border: 1px dashed rgb(217, 217, 217);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: #fafafa;
	.ant-upload-text {
		margin-top: 8px;
	}
}

.customVisible {
	::v-deep {
		.ant-modal-footer {
			border-top: none;
		}
	}
	.custom_template {
		width: 535px;
		height: 250px;
		overflow-x: auto;
		border: 1px solid #ebebeb;
		border-radius: 6px;
		font-size: 13px;
		padding: 15px;
		.custom_template_title {
			border-left: 3px solid #e63e30;
			padding-left: 6px;
			font-size: 14px;
			height: 14px;
			line-height: 14px;
			font-weight: 500;
			color: #333;
		}
		.custom_template_space {
			padding: 12px 10px;
			button {
				margin: 0 8px 8px 0;
				font-size: 13px;
				height: 28px;
				line-height: 28px;
			}
		}
	}
	.custom_template_text {
		width: 535px;
		height: 250px;
		position: relative;
		textarea {
			display: block;
			width: 100%;
			height: 100%;
			padding: 15px;
			resize: none;
			font-size: 13px;
			color: #333;
			text-indent: 70px;
			border-radius: 6px;
			outline-style: none;
			border: 1px solid hsl(0, 0%, 92%);
			white-space: pre-wrap;
			word-break: break-word;
		}
	}
	.custom_template_text::before {
		content: attr(data-title);
		position: absolute;
		left: 10px;
		top: 15px;
		font-size: 13px;
		color: #333;
	}
}
</style>
